import React from 'react';
import { SalesforceFieldSearchableSelectionTableV3 } from '@periscopes/general/fields';

export interface WorkflowRuleFieldsTabsProps {
	index: number;
	sonarObjectId: number;
}

export const WorkflowRuleFieldsTab: React.FC<WorkflowRuleFieldsTabsProps> = ({ index, sonarObjectId }) => {
	const targetUri = `v3/salesforce/workflow-rules/${sonarObjectId}/fields`;

	return (
		<SalesforceFieldSearchableSelectionTableV3
			parentIndex={ index }
			resourceIdsUri={ `${targetUri}/bulk` }
			uri={ targetUri } />
	);
};
